import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Dot = styled.div<any>`
  height: 30px;
  width: 30px;
  background-color: var(--color-indigo-t2);
  border-radius: 50%;

  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 1;
  ${(props: any) => props.active && `background: var(--color-indigo-t11);`}
`;

export const Line = styled.div`
  background-color: var(--color-indigo-t2);
  height: 5px;
  width: 100%;
  flex: 1;
`;

export const ActiveLine = styled.div<any>`
  background-color: var(--color-indigo-t11);
  height: 100%;
  transition: width 0.5s;
  ${(props: any) => props.width && `width: ${props.width};`}
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  color: #2d3540;
  font-size: 16px;

  @media (max-width: 425px) {
    font-size: 14px;
  }
`;
